import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Input = ({ label, labelClassName, error, className, id, ...props }) => {
    return (
        <div className="w-full">
            {label && (
                <label
                    htmlFor={id}
                    className={twMerge("block text-sm font-medium text-slate-700 mb-1", labelClassName)}
                >
                    {label}
                </label>
            )}
            <input
                id={id}
                className={twMerge(
                    'w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm shadow-sm placeholder-slate-400',
                    'focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500',
                    'transition-colors duration-200',
                    error && 'border-red-500 focus:border-red-500 focus:ring-red-500',
                    className
                )}
                {...props}
            />
            {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        </div>
    );
};
